module.exports = __webpack_public_path__ + "img/37.ffd93d3d.jpg";